export function topicReducer(state, action) {
  switch (action.type) {
    case "loadTopics":
      return {
        ...state,
        topics: action.topics,
      };
    case "deleteTopic":
      return {
        ...state,
        topics: state.topics.filter(
          (item) => parseInt(item.id) != parseInt(action.topicId)
        ),
      };
    case "showModal":
      return {
        ...state,
        showModal: true,
      };
    case "hideModal":
      return {
        ...state,
        showModal: false,
      };
    default:
      throw new Error();
  }
}
